import React, { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  InputAdornment,
} from "@material-ui/core";

import { Line } from "../styles/ClassificacaoServico";

import { Margin } from "../../../../theme/styles/Utils";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import TextField from "../../../../components/basics/TextFieldErp";

import { HeaderModal } from "../../../financeiro/nfe/styles/Emissao";

import useClassificacaoServicoController from "../controllers/ClassificacaoServicoController";

import { ClassificacaoServicoContext } from "../contexts/ClassificacaoServicoContext";

const ModalEditCentroNegocio = ({ open, setOpen, index }) => {
  const { tableSetCostCenters, setTableSetCostCenters, ratioLimitPercentage } =
    useContext(ClassificacaoServicoContext);

  const { handleMaxPercentage, calcMaxPercentage, rmd } =
    useClassificacaoServicoController();

  const [serviceCostDescription, setServiceCostDescription] = useState("");
  const [serviceCostPercentage, setServiceCostPercentage] = useState("0,00");
  const [percentageError, setPercentageError] = useState(false);

  const handleClose = () => {
    setServiceCostDescription("");
    setServiceCostPercentage("0,00");
    calcMaxPercentage();
    setPercentageError(false);
    setOpen(false);
  };

  useEffect(() => {
    calcMaxPercentage();
  }, [calcMaxPercentage]);

  const handleChangePercentage = (value) => {
    if (!rmd(value)) {
      setPercentageError(true);
      return;
    }

    const copyTable = [...tableSetCostCenters];

    copyTable[index].costPercentage = value;

    setTableSetCostCenters(copyTable);

    handleClose();
  };

  useEffect(() => {
    if (typeof index !== "number") return;

    setServiceCostDescription(tableSetCostCenters[index].costDescription);
    setServiceCostPercentage(
      tableSetCostCenters[index].costPercentage || "0,00"
    );
    calcMaxPercentage(tableSetCostCenters[index].costPercentage);
  }, [calcMaxPercentage, index, tableSetCostCenters]);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth={true}>
        <HeaderModal>
          <DialogTitle id="dialog-forma-pagto">
            <Chip
              label="EDITAR PORCENTAGEM"
              bgcolor="primary"
              textcolor="white"
            />
          </DialogTitle>
        </HeaderModal>

        <DialogContent>
          <Margin top="65">
            <Line container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Categoria"
                  size="small"
                  value={serviceCostDescription}
                  variant="filled"
                  disabled
                />
              </Grid>
            </Line>
            <Line container spacing={2} justifyContent="space-between">
              <Grid item xs={6}>
                <TextField
                  error={percentageError}
                  label="Porcentagem"
                  size="small"
                  value={serviceCostPercentage}
                  setValue={(e) =>
                    handleMaxPercentage(e, setServiceCostPercentage)
                  }
                  mask="decimal"
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  helperText={
                    percentageError ? "Insira uma porcentagem válida." : ""
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Porcentagem restante"
                  size="small"
                  value={ratioLimitPercentage}
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  variant="filled"
                  disabled
                />
              </Grid>
            </Line>
          </Margin>
        </DialogContent>

        <DialogActions>
          <Btn
            bgcolor="tertiary"
            hovercolor="red"
            onClick={handleClose}
            label="cancelar"
          />
          <Btn
            bgcolor="primary"
            hovercolor="orange"
            label="Confirmar"
            onClick={() => handleChangePercentage(serviceCostPercentage)}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalEditCentroNegocio;
